import 'react-slidedown/lib/slidedown.css';

import * as React from 'react';
import classnames from 'classnames';

const styles = require('./Amenities.scss');

const SlideDown = require('react-slidedown').SlideDown;

export interface State {
    isShown: boolean;
}

export interface Props {
    amenities: {
        id: number;
        name: string;
    }[];
    restrictions: {
        id: number;
        name: string;
    }[];
    showAmenities: boolean;
    showRestrictions: boolean;
    onSectionExpanded?: () => void;
    isShown: boolean;
}

export default class ServiceOptions extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isShown: props.isShown,
        };

        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.handleSectionExpanded = this.handleSectionExpanded.bind(this);
    }

    renderContent(amenities: React.ReactNode, restrictions: React.ReactNode) {
        if (this.props.showAmenities && this.props.showRestrictions) {
            return (
                <div className={styles.row}>
                    <div className={styles.column50}>{amenities}</div>
                    <div className={styles.column50}>{restrictions}</div>
                </div>
            );
        }

        if (!this.props.showAmenities && restrictions) {
            return restrictions;
        }
        if (!this.props.showRestrictions && amenities) {
            return amenities;
        }

        return null;
    }

    public render() {
        const amenities = (
            <div>
                {this.props.showAmenities && this.props.showRestrictions && (
                    <h3 className='VenuePage--additional-detail-headline'>Amenities</h3>
                )}
                <div className='VenuePage--additional-detail '>
                    {this.props.amenities.map((a, i) => (
                        <p key={i}>- {a}</p>
                    ))}
                </div>
            </div>
        );

        const restrictions = (
            <div>
                {this.props.showAmenities && this.props.showRestrictions && (
                    <h3 className='VenuePage--additional-detail-headline'>Restrictions</h3>
                )}
                <div className='VenuePage--additional-detail '>
                    {this.props.restrictions.map((r, i) => (
                        <p key={i}>- {r}</p>
                    ))}
                </div>
            </div>
        );

        return (
            <div className='VenuePage--detail VenuePage--detail__expandable '>
                <div className='VenuePage--detail-headline-container' onClick={this.handleToggleClick}>
                    <h3 className='VenuePage--detail-headline VenuePage--detail-headline__expandable'>
                        {this.props.showAmenities && this.props.showRestrictions && 'Amenities and Restrictions'}
                        {!this.props.showAmenities && 'Restrictions'}
                        {!this.props.showRestrictions && 'Amenities'}
                        <i
                            className={classnames('icon-hb-nx-arrow-down-16', { 'icon-hb-nx-arrow-down-16__flipped': this.state.isShown })}
                        />
                    </h3>
                </div>

                <div className='VenuePage--additional-detail-container'>
                    <SlideDown className={'VenuePage--row'}>{this.state.isShown && this.renderContent(amenities, restrictions)}</SlideDown>
                </div>
            </div>
        );
    }

    private handleSectionExpanded() {
        if (this.props.onSectionExpanded) {
            this.props.onSectionExpanded();
        }
    }

    private handleToggleClick(e: React.SyntheticEvent<HTMLElement>) {
        const trigger = !this.state.isShown;
        this.setState({ isShown: !this.state.isShown });

        if (trigger) {
            this.handleSectionExpanded();
        }
    }
}
